import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class MeduskladisnicaService {
  constructor(private _http: HttpClient) {}

  meduskladisnice_popis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'meduskladisnice_popis', a)
      .pipe(map((res: any) => res));
  }

  mskladMrviceDepend(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'mskladMrviceDepend', a)
      .pipe(map((res: any) => res));
  }

  artikli_za_mrvice(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'artikli_za_mrvice', a)
      .pipe(map((res: any) => res));
  }

  prometstavkePopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'prometstavkePopis', a)
      .pipe(map((res: any) => res));
  }

  pregledDokumenataStavke(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'pregled_Dokumenata_Stavke', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPrijevoznike(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_prijevoznike', a)
      .pipe(map((res: any) => res));
  }

  poslovnicaPopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }

  dodaj_meduskladisnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dodaj_meduskladisnicu', a)
      .pipe(map((res: any) => res));
  }

  uredi_meduskladisnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'uredi_meduskladisnicu', a)
      .pipe(map((res: any) => res));
  }

  zavrsi_meduskladisnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'zavrsi_meduskladisnicu', a)
      .pipe(map((res: any) => res));
  }

  zavrsi_meduskladisnicu_mrvice(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'zavrsi_meduskladisnicu_mrvice', a)
      .pipe(map((res: any) => res));
  }

  storniraj_meduskladisnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'storniraj_meduskladisnicu', a)
      .pipe(map((res: any) => res));
  }

  obrisi_meduskladisnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'obrisi_meduskladisnicu', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkePopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkePopis', a)
      .pipe(map((res: any) => res));
  }

  lotprometStavkePopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'lotprometStavkePopis', a)
      .pipe(map((res: any) => res));
  }

  dodajNoveStavkePalete(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dodaj_paletu_izlaz', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeDodaj(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeDodaj', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeUredi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeUredi', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeObrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeObrisi', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveProizvode(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_artikle', a)
      .pipe(map((res: any) => res));
  }

  artiklPopisZaPoslovnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'artiklPopisZaPoslovnicu', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveLotove(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'provjeri_lot', a)
      .pipe(map((res: any) => res));
  }

}
